import ErrorBoundary from "@COMPONENTS/common/error/ErrorBoundary";
import * as style from "@COMPONENTS/style/productlist/productlistM";
import {Flex} from "@FRAMEWORK/ui/mobile/layout";
import {GoodsByMenu} from "@QUERIES/prdt/goods/useGoodsByMenu";
import {Flag} from "@yb/ui/mobile/common/Flag";
import {format} from "@yb/utils";

interface Props {
	product: GoodsByMenu;
}

const LocalPriceComponent = ({product}: Props) => (
	<style.PriceWrap>
		<style.PriceBox>
			<Flex align="end">
				<style.PriceTag>
					{product.goodsPromotion && <style.PromotionFlag>{product.goodsPromotion.split(",")[1]}</style.PromotionFlag>}
					{product.couponYn === "Y" && <Flag $type="promotion" $flag="coupon" text="쿠폰할인" />}
				</style.PriceTag>
				{product.ypdYn === "Y" && (
					<style.BeforePrice>
						<strong>{format.koKRFormatNumber(product.ypdPrice)}</strong>원
					</style.BeforePrice>
				)}
				<style.Price>
					<strong>{format.koKRFormatNumber(product.minPrice)}</strong>원~
				</style.Price>
			</Flex>
		</style.PriceBox>
	</style.PriceWrap>
);

const LocalPrice = (props: Props) => (
	<ErrorBoundary logMsg="Product Price Error">
		<LocalPriceComponent {...props} />
	</ErrorBoundary>
);

export default LocalPrice;
